<page-title text="BitOasis Lite | Buy and Sell Bitcoin, Ether and more with 0% fees" i18n-text="@@pageTitle.brokerLanding"></page-title>
<page-meta
    description="Directly buy and sell crypto assets with fiat currency. Compliant with local regulatory authorities and international best practice."
    i18n-description="@@pageMeta.description.broker">
</page-meta>
<site-layout class="white full">
  <section class="group mt-5">
    <h1 class="main-title" i18n="@@front.broker.lite.title">Crypto trading made easy.<br/><span class="green">BitOasis Lite is for everyone.</span></h1>
    <div class="desktop-image">
       <img src="assets/images/core/{{lang}}/main-full.webp" alt="" class="w-100" />
    </div>
    <div class="group-small">
      <p i18n="@@front.broker.lite.buySell"><b>Buy, Sell, Swap</b> — you’re a few steps away from starting your crypto journey.</p>
      <a routerLink="/register" class="btn btn-primary" i18n="@@front.broker.lite.ststartTrading">Start Trading</a>
      <p class="label" i18n="@@front.broker.lite.signUpLabel">Sign up now, it takes no more than 3 minutes</p>
    </div>
  </section>

  <section class="group gray">
    <div class="crypto-group">
      <img src="assets/images/core/{{lang}}/phone.webp" class="crypto-phone-img d-none d-md-block" alt="" />
      <img src="assets/images/core/{{lang}}/main-mobile.webp" class="crypto-phone-img d-md-none" alt="" />
      <div class="crypto-info info-content">
        <h2 class="header-title" i18n="@@front.broker.lite.crypto.title">An Easy Way to Trade Crypto</h2>
        <p i18n="@@front.broker.lite.crypto.info0">Buying crypto with Lite is easy, just select crypto you want to trade, click confirm and it’s done.</p>
        <p i18n="@@front.broker.lite.crypto.info1">We offer the most convenient ways to deposit, including Visa & Mastercard, bank transfers, or by linking your personal account for 0% fees funding*.</p>
        <div class="crypto-stores">
          <img class="card-img-visa" src="assets/images/credit-cards/light/Visa.svg" alt="">
          <div class="p-3"></div>
          <img class="card-img-mc" src="assets/images/credit-cards/light/mastercard-with-title.svg" alt="">
          <div class="p-3"></div>
          <div class="d-flex d-md-inline-flex" [ngClass]="{ 'd-none': !isOS }">
            <a class="btn-link" href="https://apple.co/31XHi3T" target="_blank" rel="noopener">
              <i class="icon-app-store"></i>
            </a>
            <div class="p-3"></div>
          </div>
          <a
            class="btn-link d-md-inline-flex"
            [ngClass]="{ 'd-none': isOS }"
            href="https://play.google.com/store/apps/details?id=com.bitoasis&hl={{lang}}"
            target="_blank"
            rel="noopener"
          >
            <i class="icon-google-play"></i>
          </a>
        </div>
        <p class="text-start mt-2" i18n="@@front.broker.lite.crypto.info3">*Easy Funding available in UAE only</p>
      </div>
    </div>
  </section>

  <section class="group">
    <div class="buysell-group">
      <ng-container *ngTemplateOutlet="buysellTitle, context: { mobile: true }"></ng-container>
      <video autoplay muted loop playsinline #videoDesktop class="lite-video">
        <source src="assets/video/core/{{lang}}/desktop.webm" type="video/webm">
        <source src="assets/video/core/{{lang}}/desktop.mp4" type="video/mp4">
      </video>
      <div class="buysell-info info-content">
        <ng-container *ngTemplateOutlet="buysellTitle"></ng-container>
        <video autoplay muted loop playsinline #videoMobile class="lite-video-mobile">
          <source src="assets/video/core/{{lang}}/mobile.webm" type="video/webm">
          <source src="assets/video/core/{{lang}}/mobile.mp4" type="video/mp4">
        </video>
        <p class="mb-1" i18n="@@front.broker.lite.buysell.info">Invest and trade the most popular cryptocurrencies, with over 250 trading pairs.</p>
        <a routerLink="/page/supported-tokens" class="w-100 d-inline-block" i18n="@@front.broker.lite.buysell.link">Explore all crypto assets.</a>
        <a routerLink="/register" class="btn btn-primary mt-4" i18n="@@front.broker.lite.ststartTrading">Start Trading</a>
        <p class="label" i18n="@@front.broker.lite.signUpLabel2">Sign up in less than 3 minutes.</p>
      </div>
    </div>
  </section>
  
  <section class="group">
    <ul class="steps">
      <li class="step">
        <div class="icon-panel">
          <i class="icon-signup"></i>
        </div>
        <div>
          <p class="subtitle" i18n="@@front.broker.lite.step1.title">Sign up</p>
          <p class="mb-1" i18n="@@front.broker.lite.step1.text">Create your BitOasis account.</p>
          <p class="label" i18n="@@front.broker.lite.step1.info">1 min</p>
        </div>
      </li>
      <li class="step">
        <div class="icon-panel">
          <i class="icon-verify"></i>
        </div>
        <div>
          <p class="subtitle" i18n="@@front.broker.lite.step2.title">Verify</p>
          <p class="mb-1" i18n="@@front.broker.lite.step2.text">Verify your account to start using our services.</p>
          <p class="label" i18n="@@front.broker.lite.step2.info">3 mins</p>
        </div>
      </li>
      <li class="step">
        <div class="icon-panel">
          <i class="icon-deposit"></i>
        </div>
        <div>
          <p class="subtitle" i18n="@@front.broker.lite.step3.title">Deposit</p>
          <p class="mb-1" i18n="@@front.broker.lite.step3.text">Deposit your funds securely through our supported channels.</p>
          <p class="label" i18n="@@front.broker.lite.step3.info">5+ methods supported</p>
        </div>
      </li>
      <li class="step">
        <div class="icon-panel">
          <i class="icon-trading"></i>
        </div>
        <div>
          <p class="subtitle" i18n="@@front.broker.lite.step4.title">Start trading</p>
          <p class="mb-1" i18n="@@front.broker.lite.step4.text">Buy, Sell or Swap {{ (currencies$ | async)?.length || 80 }}+ crypto assets on Lite.</p>
          <a routerLink="/page/fees" class="text-md" i18n="@@front.broker.lite.step4.info">Check fees</a>
        </div>
      </li>
    </ul>
  </section>

  <section class="group">
    <img src="assets/images/core/Faces.webp" class="img-faces" alt="">
    <h2 class="header-title mt-2" i18n="@@front.broker.lite.signup.title">Trusted by <span class="green">200,000+</span> traders</h2>
    <p class="mb-4" i18n="@@front.broker.lite.signup.text">Join our community, and be a part of an open financial ecosystem.</p>
    <a routerLink="/register" class="btn btn-primary" i18n="@@front.broker.lite.signup.button">Sign up now</a>
  </section>

  <section class="group group-pro dark">
    <h2 i18n="@@front.broker.lite.pro.title">Looking for <span class="green">Pro</span> trading?</h2>
    <p i18n="@@front.broker.lite.pro.info">Check Bitoasis Pro - Chart analysis, advanced market orders, and more.<br/>Both Lite and Pro are available for all users, any time.</p>
    <a routerLink="/register" class="btn btn-primary mb-5" i18n="@@front.broker.lite.pro.link">Check BitOasis Pro</a>
    <div class="pro-full-image d-none d-md-block">
      <img src="assets/images/core/{{lang}}/pro-full.webp" alt="">
    </div>
    <div class="d-md-none mt-5">
      <img class="pro-image" src="assets/images/core/{{lang}}/pro-mobile.webp" alt="">
    </div>
  </section>
</site-layout>
<site-footer></site-footer>

<ng-template #buysellTitle let-mobile="mobile">
  <h2
    class="header-title"
    i18n="@@front.broker.lite.buysell.title"
    [ngClass]="{ 'd-md-none': mobile, 'd-none': !mobile, 'd-md-inline': !mobile }"
  >
    {{ (currencies$ | async)?.length || 80 }}+ crypto assets ready to <b>buy</b>, <b>sell</b> or <b>swap</b>
  </h2>
</ng-template>
